import { useState, useCallback, useEffect, useContext } from "react";
import { AccountTypes } from "../store/actions";
import { AppContext } from "../store";
import { useMsal } from "../utils/authContext";

const useIsFullyAuthenticated = () => {
    const { loading, isAuthenticated: hasToken, login, logout, user, getToken } = useMsal();
    const [authenticationChecked, setAuthenticationChecked] = useState(hasToken);
    const [isAuthenticated, setValue] = useState(hasToken);
    const { state, dispatch } = useContext(AppContext);
    const authenticationStateStateNotSaved = hasToken && !state.accountInfo.homeAccountId;
    const hasAuthUserError = state.orgInfo.error;
    const setAuthenticated = useCallback((token: boolean) => {
        setValue(token);
    }, []);
    useEffect(() => {
        if (hasAuthUserError) {
            return;
        }
        if (authenticationStateStateNotSaved) {
            dispatch({
                type: AccountTypes.SetUser,
                payload: user,
            });
            setAuthenticated(true);
        }
    }, [hasAuthUserError, authenticationStateStateNotSaved, user, dispatch, setAuthenticated]);
    useEffect(() => {
        if (!loading && !authenticationChecked){
            setAuthenticationChecked(true);
        } 
    },[authenticationChecked, loading]);
    
    return { isAuthenticated, loading, login, logout, user, getToken, authenticationChecked };
}
export default useIsFullyAuthenticated;